<div class="kasa-container">
	<mat-card class="kasa-card">
		<mat-card-content>
			<div class="search-bar">
				<mat-form-field appearance="outline" subscriptSizing="dynamic" class="search-field">
					<mat-label>Szukaj w Kasie</mat-label>
					<input
						matInput
						[formControl]="searchControl"
						placeholder="Kierowca, pojazd, kategoria, opis..."
						autocomplete="off"
					/>
					<i class="fas fa-search search-icon" matIconPrefix aria-hidden="true"></i>
					@if (searchControl.value) {
						<button
							matIconSuffix
							mat-icon-button
							type="button"
							aria-label="Wyczyść wyszukiwanie"
							matTooltip="Wyczyść wyszukiwanie"
							(click)="clearSearch()"
						>
							<i class="fas fa-times"></i>
						</button>
					}
				</mat-form-field>
			</div>

			@if (searchQuery()) {
				<app-driver-ledger-search-results [query]="searchQuery()" />
			} @else {
				<div class="filters-bar">
					<mat-form-field
						appearance="outline"
						subscriptSizing="dynamic"
						class="filter-field filter-field--driver"
					>
						<mat-label>Kierowca</mat-label>
						<input matInput [formControl]="driverFilterControl" placeholder="Szukaj kierowcę..." />
					</mat-form-field>

					<div class="filter-group">
						<span class="filter-group-label">PLN</span>
						<mat-form-field
							appearance="outline"
							subscriptSizing="dynamic"
							class="filter-field filter-field--amount"
						>
							<mat-label>od</mat-label>
							<input matInput type="number" [formControl]="plnMinControl" />
						</mat-form-field>
						<mat-form-field
							appearance="outline"
							subscriptSizing="dynamic"
							class="filter-field filter-field--amount"
						>
							<mat-label>do</mat-label>
							<input matInput type="number" [formControl]="plnMaxControl" />
						</mat-form-field>
					</div>

					<div class="filter-group">
						<span class="filter-group-label">EUR</span>
						<mat-form-field
							appearance="outline"
							subscriptSizing="dynamic"
							class="filter-field filter-field--amount"
						>
							<mat-label>od</mat-label>
							<input matInput type="number" [formControl]="eurMinControl" />
						</mat-form-field>
						<mat-form-field
							appearance="outline"
							subscriptSizing="dynamic"
							class="filter-field filter-field--amount"
						>
							<mat-label>do</mat-label>
							<input matInput type="number" [formControl]="eurMaxControl" />
						</mat-form-field>
					</div>

					<mat-checkbox [formControl]="onlyWithEntriesControl">Tylko z wpisami</mat-checkbox>

					@if (hasActiveFilters) {
						<button
							type="button"
							(click)="clearFilters()"
							matTooltip="Wyczyść filtry"
							class="clear-filters-btn"
						>
							<i class="fas fa-times"></i>
						</button>
					}
				</div>

				<div class="totals-bar">
					<span class="totals-label">Suma wszystkich kierowców:</span>
					<span class="totals-value" [class.positive]="sumPln() > 0" [class.negative]="sumPln() < 0">
						{{ sumPln() | priceCurrency: 'PLN' }}
					</span>
					<span class="totals-separator">/</span>
					<span class="totals-value" [class.positive]="sumEur() > 0" [class.negative]="sumEur() < 0">
						{{ sumEur() | priceCurrency: 'EUR' }}
					</span>
				</div>

				@if (isLoading()) {
					<div class="loading-state">
						<mat-spinner diameter="48"></mat-spinner>
					</div>
				} @else if (rows().length === 0) {
					<div class="empty-state">
						<p>Brak danych do wyświetlenia.</p>
					</div>
				} @else {
					<mat-table
						[dataSource]="rows()"
						matSort
						[matSortActive]="sortBy() ?? ''"
						[matSortDirection]="sortDirection() ?? ''"
						(matSortChange)="onSortChange($event)"
						class="kasa-table mat-elevation-z1"
					>
						<ng-container matColumnDef="driver">
							<mat-header-cell *matHeaderCellDef>Kierowca</mat-header-cell>
							<mat-cell *matCellDef="let row">
								<span class="driver-cell">
									<span>{{ row.lastName }} {{ row.firstName }}</span>
									@if (row.isInactive) {
										<span
											class="inactive-badge"
											matTooltip="Kierowca nieaktywny — widoczny w kasie, bo ma niezerowe saldo"
										>
											<i class="fa-solid fa-user-slash" aria-hidden="true"></i>
											Nieaktywny
										</span>
									}
								</span>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="totalPln">
							<mat-header-cell *matHeaderCellDef mat-sort-header="total_pln">Razem PLN</mat-header-cell>
							<mat-cell *matCellDef="let row">
								<span [class.positive]="row.totalPln > 0" [class.negative]="row.totalPln < 0">
									{{ row.totalPln | priceCurrency: 'PLN' }}
								</span>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="totalEur">
							<mat-header-cell *matHeaderCellDef mat-sort-header="total_eur">Razem EUR</mat-header-cell>
							<mat-cell *matCellDef="let row">
								<span [class.positive]="row.totalEur > 0" [class.negative]="row.totalEur < 0">
									{{ row.totalEur | priceCurrency: 'EUR' }}
								</span>
							</mat-cell>
						</ng-container>

						<ng-container matColumnDef="lastUpdated">
							<mat-header-cell *matHeaderCellDef mat-sort-header="last_updated"
								>Ostatnia aktualizacja</mat-header-cell
							>
							<mat-cell *matCellDef="let row">
								@if (row.lastUpdated) {
									<div class="last-updated-cell">
										<span class="last-updated-date">{{ row.lastUpdated | formatDateTime }}</span>
										@if (row.lastUpdatedBy) {
											<span class="last-updated-by">{{ row.lastUpdatedBy }}</span>
										}
									</div>
								} @else {
									<span class="no-data">—</span>
								}
							</mat-cell>
						</ng-container>

						<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
						<mat-row
							*matRowDef="let row; columns: displayedColumns"
							(click)="openDriver(row)"
							class="clickable-row"
							[class.inactive-row]="row.isInactive"
						></mat-row>
					</mat-table>

					<mat-paginator
						[length]="totalRecords()"
						[pageSize]="pageSize()"
						[pageIndex]="currentPage() - 1"
						[pageSizeOptions]="[10, 20, 50, 100]"
						(page)="onPageChange($event)"
					></mat-paginator>
				}
			}
		</mat-card-content>
	</mat-card>
</div>
